// @flow
import React, { PureComponent, type ChildrenArray, type Node } from 'react';

import { cleanAnchor } from 'Utils/anchor/anchorUtils';
import { IntersectionObserver } from 'Components/frameworks/intersection-observer/IntersectionObserver.jsx';

type Props = {
  children?: ChildrenArray<Node>,
  className?: string,
  name: string,
  index: number,
  onSectionIntersectViewport: (*) => *,
};

export class Section extends PureComponent<Props> {
  intersectionObserverThreshold: Array<*>;

  static defaultProps = {
    name: '',
  };

  constructor(props: Props) {
    super(props);

    this.intersectionObserverThreshold = [];
    for (let i = 0; i <= 1.0; i += 0.01) {
      // Get notified of every percent of visiblity change in the viewport (1% of intersection to 100%)
      this.intersectionObserverThreshold.push(Math.round(i * 100) / 100);
    }
  }

  render() {
    const { children, className, index, name } = this.props;

    return (
      <IntersectionObserver
        onChange={this.props.onSectionIntersectViewport}
        threshold={this.intersectionObserverThreshold}
      >
        <section
          className={className}
          data-index={index}
          data-testid="section"
          id={name ? cleanAnchor(name) : null}
        >
          {children}
        </section>
      </IntersectionObserver>
    );
  }
}
